module.exports = __webpack_public_path__ + "img/arrow-v2-number-pad.e3ca3271.svg";